// Module
var code = "<div class=bible> <div class=bibletext> <p> </p><h2 class=pn>Psalm&nbsp;11</h2><p><span class=cwvnum>1</span>&nbsp;&nbsp;In the Lord have I taken refuge;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;how then can you say to me,<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#145;Flee like a bird to the hills,<br> </p> </div></div>";
// Exports
module.exports = code;